import React from 'react';
import { useLocation } from 'react-router-dom';
import { SEO } from './SEO';
// Define your default meta tags here with enhanced conversational language for voice search
const defaultMetaTags = {
  title: 'Professional Local HVAC Services in Southwest Florida',
  description: 'Need reliable AC repair or installation in Southwest Florida? Air-Mazing Air provides 24/7 emergency HVAC services in Cape Coral, Fort Myers, and surrounding areas. Call us today at 239-888-6268 for fast, professional service.',
  ogImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/1JGevbSoLh1AeBrRR9hz3Q/IMG_1783.jpg',
  keywords: 'HVAC, air conditioning, AC repair, AC installation, duct cleaning, air quality, Cape Coral, Fort Myers, Southwest Florida, emergency AC repair, 24/7 HVAC service'
};
// Define page-specific meta tags with enhanced conversational language
const pageMetaTags = {
  '/': {
    title: 'Professional HVAC Services in Southwest Florida | 24/7 Emergency AC Repair',
    description: 'Looking for reliable AC repair in Southwest Florida? Air-Mazing Air provides 24/7 emergency HVAC services, AC installation, and maintenance in Cape Coral, Fort Myers, and surrounding areas. Call 239-888-6268 for same-day service.',
    canonicalUrl: '/',
    ogType: 'website',
    keywords: 'HVAC, air conditioning, AC repair, AC installation, duct cleaning, air quality, Cape Coral, Fort Myers, Southwest Florida, emergency AC repair, 24/7 HVAC service'
  },
  '/blog': {
    title: 'HVAC Blog - Tips, News & Insights for Southwest Florida Homeowners',
    description: 'Looking for ways to save on energy bills or troubleshoot AC problems? Our HVAC blog offers expert advice, maintenance tips, and energy-saving strategies specifically for Southwest Florida homes.',
    canonicalUrl: '/blog',
    ogType: 'blog',
    ogImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/dfdoXx5h84GymbJXQ9SBKB/air-conditioner-ventilation-installation-system-in-2025-03-27-06-10-19-utc.jpg',
    keywords: 'HVAC tips, air conditioning maintenance, energy saving, HVAC blog, AC troubleshooting, Florida HVAC advice, reduce energy bills'
  }
  // Add more pages as needed
};
interface MetaTagsManagerProps {
  customMetaTags?: {
    title?: string;
    description?: string;
    canonicalUrl?: string;
    ogImage?: string;
    ogType?: string;
    keywords?: string;
    author?: string;
    noIndex?: boolean;
    noFollow?: boolean;
    schema?: any;
  };
}
export const MetaTagsManager: React.FC<MetaTagsManagerProps> = ({
  customMetaTags = {}
}) => {
  const location = useLocation();
  const pathname = location.pathname;
  // Get page-specific meta tags or use defaults
  const pageSpecificTags = pageMetaTags[pathname] || {};
  // Combine default, page-specific, and custom meta tags with custom taking highest priority
  const metaTags = {
    ...defaultMetaTags,
    ...pageSpecificTags,
    ...customMetaTags
  };
  return <SEO title={metaTags.title} description={metaTags.description} canonicalUrl={metaTags.canonicalUrl} ogImage={metaTags.ogImage} ogType={metaTags.ogType} keywords={metaTags.keywords} author={metaTags.author} noIndex={metaTags.noIndex} noFollow={metaTags.noFollow} schema={metaTags.schema} data-id="element-285" />;
};